import { GetEditInfo} from "..";
import { dialogUtil, ui } from "../util";
import Vue from "vue";

declare var document:any;

/**
 * 外字入力ダイアログ
 * 画像アップロード、画像配置の処理を提供するクラス
 */
export class GaijiLogic {

// #region ■定数
	// Vue.jsオブジェクト
	protected _vue: Vue;
// #endregion

// #region ■プロパティ
	// 挿入対象のテキストボックス
	public TargetDivId: string; 
// #endregion

// #region ■メンバー変数
	// 外字の一覧データ
	private _gaijiList: GetEditInfo.GetEditInfoGaijiEntity[];
	// 外字入力を許可する対象
	private _allowGaijiDiv: string[] = ["address1", "address2", "address3", "companyInput", "departmentInput", "positionInput", "lastNameKanaInput", "lastNameInput1", "firstNameKana1Input", "firstName1Input", "etc1Input", "firstNameKana2Input", "firstName2Input", "etc2Input", "firstNameKana3Input", "firstName3Input", "etc3Input", "firstNameKana4Input", "firstName4Input", "etc4Input", "firstNameKana5Input", "firstName5Input", "etc5Input", "firstNameKana6Input", "firstName6Input", "etc6Input", "senderInput_phrase1"];
// #endregion

// #region ■公開メソッド

	public Init(v: Vue): void {
		this._vue = v;

		this.scrollWindowInit();
		this.resizeWindowInit();
    }

    /**
     * 外字をセットする。
     * @param list
     */
    public SetGaijiList(list:GetEditInfo.GetEditInfoGaijiEntity[]): void {
		this._gaijiList = list;
    }

	/**
	 * 外字ボタンを活性化するかしないかの制御
	 * @param id
	 */
	public ShowButton(id: string, gaijiFlg: boolean): boolean {
		//console.log('ShowButton;', id);
		let isTarget = this._allowGaijiDiv.find(x => x == id);
		if (isTarget && gaijiFlg) {
			$("#gaijiInputLbl").removeClass("is-disabled");
			return true;
		} else {
			$("#gaijiInputLbl").addClass("is-disabled");
			return false;
        }

    }

	/**
	 * 外字ボタンを非活性にする。
	 * */
	public DisplayNoneGaijiButton(): void {
		$("#gaijiInputLbl").addClass("is-disabled");
    }

	/**
	 * 外字ボタンを表示する。
	 * */
	public DisplayOnGaijiButton(): void {
		$("#gaijiInputLbl").css('display', '');
	}

    /**
     * 外字リストを表示する。
     * @param targerId
     */
	public ShowGaijiList(): void {

		//console.log('target', this.targetDivId);

		dialogUtil.showLoading();

		// 少し待つことでloadingが表示される。
		setTimeout(() => {
			setGaijiFunc();
		}, 50);

		let setGaijiFunc = () => {
			//外字リスト作成
			if ($('.gaijiRow').length <= 0) {

				var list = '';
				this._gaijiList.forEach((val, idx) => {
					list += '<li class="gaijiRow">';
					list += '<ul class="row">';
					list += '<li class="yomi">' + val.yomi + '</li>';
					list += '<li class="moji labelAddresListName">' + val.character + '</li>';
					list += '</ul>';
					list += '</li>';
				});

				list += '<li class="gaijiRowPop">';
				list += '<ul class="row">';
				list += '<li class="yomi">hoge</li>';
				list += '<li class="moji labelAddresListName">hoge</li>';
				list += '</ul>';
				list += '</li>';

				// スクロールバー更新
				$('#gaijiSelectListTable').html(list);

				//外字選択完了時のイベント紐付け
				var that = this;
				$(".gaijiRow").click(function (event) {
					let moji = $(this).find('.moji').text();
					that.SetGaiji(moji);
					return false;
				});

				let ISPC = ($('#isPC').val() + "").toLocaleLowerCase() == 'true' ? true : false;
				if (ISPC) {
					// マウスオーバー時は拡大表示
					$(".gaijiRow").hover(function () {
						var valLeft = $(this).position().left;
						var valTop = $(this).position().top;
						var valWidth = $(this).outerWidth(true);
						var valHeight = $(this).outerHeight(true);
						let parent = $("#gaijiSelectListTable").height();

						// ポップアップ
						$(".gaijiRowPop").css('left', valLeft);
						$(".gaijiRowPop").css('top', valTop);
						$(".gaijiRowPop .yomi").text($(this).find('.yomi').text());
						$(".gaijiRowPop .moji").text($(this).find('.moji').text());

						let idx = $("li.gaijiRow").index(this);

						let row = idx % 12;
						let column = Math.floor(idx / 12);

						// エリアからはみださないように位置調整(要調整)
						$(".gaijiRowPop").css('top', (column * valHeight));
						if (valLeft <= 70) {
							// 左はみだし
							$(".gaijiRowPop").css('left', 28);
						}
						if (valLeft >= 800) {
							// 右はみだし
							$(".gaijiRowPop").css('left', valLeft - 4);
						}
						if (valTop <= 100) {
							// 上はみだし
							let currentTop = parseInt($(".gaijiRowPop").css('top'));
							let calcTop = currentTop + 35;
							$(".gaijiRowPop").css('top', calcTop);
						}
						if (valTop >= 490) {
							$(".gaijiRowPop").css('bottom', (column * valHeight) + valHeight);
						}

						// PC版headerを非表示
						if (ui.usePcDesign()) $('header').addClass('is-hidden');

						$(".gaijiRowPop").css('display', 'block');
					});
				}
			}

			$(".gaijiRowPop").css('display', 'none');

			//外字選択完了時のイベントと入力欄紐付け
			$('#popGaijiCancel').unbind('click');
			$('#popGaijiCancel').bind('click', () => {
				this.closeGaijiDialog();
			});
			dialogUtil.closeLoading();
			$('body').addClass('anmDialog');
			$('.gaijiSelect').addClass('c-modalDialog__panel--hasClose');
		}
		
	}

	/**
	 * 外字を使用しているかチェックする。
	 * */
	public IsUseGaiji(): boolean {
		dialogUtil.showLoading();
		let rt = false;
		rt = this._allowGaijiDiv.some((x) => {
			let txt = $("#" + x).val() + "";
			if (txt) {
				for (let i = 0; i < txt.length; i++) {
					let c = txt.charCodeAt(i);
					// 私用領域内か？
					let mySpaceStart = parseInt('E000', 16); //57344
					let mySpaceEnd = parseInt('F8FF', 16); //63743
					if (c >= mySpaceStart && c <= mySpaceEnd) {
						return true;
                    }
                }
			}
		})
		dialogUtil.closeLoading();
		return rt;
    }

// #endregion

// #region ■イベント

	/**
	 * 外字入力の表示ダイアログ
	 * @param event
	 */
	public gaijiInput(event: JQueryEventObject): void {
		if (this.TargetDivId) {
			// 外字挿入対象があれば、外字リストを表示する。
			this.ShowGaijiList();
		}
	}
	/**
	 * 外字ボタンの表示制御
	 * @param event
	 */
	public gaijiButtonEnable(event: JQueryEventObject, gaijiFlg: boolean): void {

		// 挿入対象の初期化
		this.TargetDivId = "";

		// idチェック
		if (!event.target.id)
			return;

		let targetIdName = event.target.id;
		// console.log('id', targetIdName);

		let showFlg = this.ShowButton(targetIdName, gaijiFlg);
		if (showFlg) {
			// 挿入対象を覚えておく。
			this.TargetDivId = targetIdName;

			// 該当の情報を取得して、移動
			this.moveGaijiShortCut(targetIdName);
		}
		if (!ui.usePcDesign()) {
			this._vue.$data.Show.GaijiShortCutBtn = showFlg && this._vue.$data.Show.GaijiShortCutBtn;
			this._vue.$data.FocusGaijiShortCut = showFlg ? targetIdName: '';
        }
	}
	/**
	 * 外字ボタンのショートカットの表示制御
	 * @param targetIdName
	 */
	private moveGaijiShortCut(targetIdName: string): void {
		if (ui.usePcDesign()) {
			return;
		}

		// フォーカスの位置情報の取得
		const gaijiShortCutSize = (<HTMLInputElement>this._vue.$refs[targetIdName])?.getBoundingClientRect();

		// ショートカット情報
		// 表示前に値を取得する場合は、各種値が0となるため初期値を入れておく必要あり
		const shortCutWidth = this._vue.$data.Show.GaijiShortCutBtn ?
			(<HTMLInputElement>this._vue.$refs.gaijiShortCut).getBoundingClientRect().width : 25;
		const shortCutHeight = this._vue.$data.Show.GaijiShortCutBtn ?
			(<HTMLInputElement>this._vue.$refs.gaijiShortCut).getBoundingClientRect().height : 25;

		const topPos = window.pageYOffset + gaijiShortCutSize?.bottom + 1;

		// 移動
		this._vue.$data.ReplaceGaijiShortCut.top = topPos + "px";
		this._vue.$data.ReplaceGaijiShortCut.left = (gaijiShortCutSize?.right - shortCutWidth) + "px";

		// ショートカットの位置がヘッダーorフッターと被った場合は非表示にする
		if (topPos < 50 ||
			(topPos + shortCutHeight) > window.pageYOffset + (<HTMLInputElement>this._vue.$refs.senderMenuArea)?.getBoundingClientRect().top) {
			this._vue.$data.Show.GaijiShortCutBtn = false;
		} else {
			this._vue.$data.Show.GaijiShortCutBtn = true;
		}
	}

	private scrollWindowInit(): void {
		$('#senderEditPage').on('scroll', () => {
			// PCの場合は抜ける
			if (ui.usePcDesign()) return;

			if (this.TargetDivId?.length == 0 && !this._vue.$data.Show.GaijiShortCutBtn) {
				return;
			}
			this.moveGaijiShortCut(this._vue.$data.FocusGaijiShortCut);
		});
	}

	private resizeWindowInit(): void {
		visualViewport.addEventListener('resize', () => {
			// PCの場合は抜ける
			if (ui.usePcDesign()) return;

			if (this.TargetDivId?.length == 0 && !this._vue.$data.Show.GaijiShortCutBtn) {
				return;
			}
			// フォーカスしようとしている要素と現在フォーカスしている要素が異なるときは
			// 現在を優先する
			// 外字のショートカットボタンの非表示
			// フッターの外字ボタンの無効化
			if ($(':focus')[0]?.id != this.TargetDivId) {
				this._vue.$data.Show.GaijiShortCutBtn = false;
				this.DisplayNoneGaijiButton();
				return;
			};

			this.moveGaijiShortCut(this.TargetDivId);

			if (!this._vue.$data.FocusGaijiShortCut) {
				this._vue.$data.Show.GaijiShortCutBtn = false;
				return;
			};
			(<HTMLInputElement>this._vue.$refs[this._vue.$data.FocusGaijiShortCut]).focus();
        });
    }

// #endregion

	/**
	 * ダイアログを閉じる。
	 * */
	private closeGaijiDialog():void { 
		$('body').removeClass('anmDialog');
		$('.gaijiSelect').removeClass('c-modalDialog__panel--hasClose');
		if (this._vue.$data.FocusGaijiShortCut) {
			(<HTMLInputElement>this._vue.$refs[this._vue.$data.FocusGaijiShortCut]).focus();
		}
	}

	/**
	 * 対象テキストボックスに外字を挿入する。
	 * */
	private SetGaiji(moji:string): void {
		let id = "#" + this.TargetDivId;
		posw_InsertAtCaret(id, moji);
		this.closeGaijiDialog();
    }

}
//テキストボックスのキャレット位置に文字を挿入する
function posw_InsertAtCaret(target, str) {
	var obj = $(target);
	obj.focus();
	if (navigator.userAgent.match(/MSIE/)) {
		var r = document.selection.createRange();
		r.text = str;
		r.select();
	} else {
		var s = obj.val();
		var aaa = obj.get(0) as any;
		var p = aaa.selectionStart;
		var np = p + str.length;
		obj.val(s.substr(0, p) + str + s.substr(p));
		aaa.setSelectionRange(np, np);
	}
	// そのままだとvueへのバインドが発火しないので、ここでイベントを強制発火
	obj[0].dispatchEvent(new CustomEvent('input'));
}